<template>
  <div>
    <div class="bk">
      <div class="headerTitle">集团介绍</div>
    </div>
    <div class="title">集团介绍</div>
    <div class="introduce">
      <p class="all">
        <!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;深圳昌恩智能股份有限公司成立于1998年5月22日，是经广东省公安厅、广东省住建厅批准认证、在建设“智慧城市”背景下为客户提供智能化整体解决方案的综合性企业。公司目前以城市和建筑智能化、智能交通为主营业务，建筑智能化服务领域遍及政府机构、金融行业、教育、医疗、公安边防、文博系统、旅游景点、小区酒店、智慧城市等，智能交通应用涉及出租车、网约车、两客一危及车辆运营监管平台等。
        <br /><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司目前拥有广东省公安厅《广东省安全技术防范系统设计、施工、维修资格证（壹级）》、中国安防协会《安防工程企业设计施工维护能力证书（壹级）》、广东省住建厅《建筑业企业资质证书－电子与智能化工程专业承包一级》、深圳市住建局《建筑业企业资质证书－建筑机电安装工程专业承包二级》、中国电子信息行业联合会《信息系统建设和服务能力等级证书（CS2）》、广东省住建厅《安全生产许可证》、深圳市盐田区住建局《建筑业企业资质证书－施工劳务》。
        <br /><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司先后获得《工程建设施工组织质量管理体系认证证书》、《环境管理体系认证证书》、《职业健康安全管理体系认证证书》、《两化融合管理体系评定证书》、《知识产权管理体系认证证书》、美国软件工程学会《CMMI３认证证书》。公司被认定为《网约车智能终端系统工程技术研究中心》、《国家高新技术企业》、《深圳双软企业》、《深圳市专精特新中小企业》。“昌恩智能”品牌入选第十六届、第十九届“深圳知名品牌”。
        <br /><br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2016年5月20日，昌恩智能正式登陆资本市场，在全国中小企业股份转让系统挂牌交易，股票简称：昌恩智能；股票代码：837544。 -->
      </p>
      <div class="all">
        <p style="text-indent: 2em">
          深圳昌恩智能股份有限公司成立于1998年5月22日，是深耕于城市与建筑智能化、智慧交通、智慧能源等信息与智能化建设领域的综合解决方案提供商,昌恩智能是国家高新技术企业、深圳市专精特新中小企业,昌恩智能目前拥有三大业务板块，分别为“城市和建筑智能化解决方案”“智慧交通解决方案”与“智慧能源解决方案”。昌恩智能为新三板挂牌公司,股票代码:837544。
        </p>
        <br />
        <p style="text-indent: 2em">
          昌恩智能拥有《广东省安全技术防范系统设计、施工、维修资格证(壹级)》《安防工程企业设计施工维护能力证书(壹级)》《建筑业企业资质证书--电子与智能化工程专业承包壹级》《建筑业企业资质证书--建筑机电安装工程专业承包二级》《建筑业企业资质证书--施工劳务》《安全生产许可证》《信息系统建设和服务能力等级证书(CS2)》《工程建设施工组织质量管理体系认证证书》、《环境管理体系认证证书》《职业健康安全管理体系认证证书》《知识产权合规管理体系认证证书》《信息技术服务管理体系认证证书
          》《信息安全管理体系认证证书》《CMMI3认证证书》《广东省科技厅网约车智能终端系统工程技术研究中心》《国家高新技术企业》《深圳市专精特新中小企业》《深圳知名品牌》等资质认证与荣誉。
        </p>
      </div>
    </div>
    <!-- <span class="name">集团架构</span> -->
    <!-- <el-image-viewer
      referrerPolicy="no-referrer"
      v-if="showViewer"
      :on-close="showViewerClose"
      :url-list="[url]"
    ></el-image-viewer> -->
    <!-- <el-button type="primary" size="small" @click="show"> </el-button>
    <el-button type="primary" size="small" @click="downPreview"></el-button> -->

    <!-- <div class="imgCe" v-viewer="options">
      <img
        :src="require('../assets/img/集团架构.png')"
        class="image"
        :data-src="require('../assets/img/7659790acff7406fde1ff0723844760.jpg')"
      />
    </div> -->
    <div class="bm">
      <span>
        版权所有©深圳昌恩智能股份有限公司　
        <a style="color: #fff" target="_blank" href="http://beian.miit.gov.cn"
          >粤ICP备17113788号</a
        ></span
      >
    </div>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  name: 'introduction',
  mounted () {
    window.scrollTo(0, 0)
  },
  data () {
    return {
      options: {
        url: 'data-src'
      },
      showViewer: false,
      url: 'https://www.szce.com:12000/imgs/2022/11/09/1667984818051编组all.jpeg'
    }
  },
  components: { ElImageViewer },
  methods: {
    show () {
      const viewer = this.$el.querySelector('.imgCe').$viewer
      viewer.show()
    },

    downPreview () {
      console.log('aaa')
      var name =
        'https://www.szce.com:12000/imgs/2022/11/09/1667984818051编组all.jpeg'
      const element = document.createElement('a')
      element.setAttribute('download', name)
      let binaryData = []
      binaryData.push(name)
      element.setAttribute(
        'href',
        window.URL.createObjectURL(new Blob(binaryData))
      )
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
    },
    showViewerClose () {
      console.log('11111')
      this.showViewer = false
    },
    getPreview () {
      console.log('222')
      console.log(this.url + '=====')
      this.url
        ? (this.showViewer = true)
        : this.$message.info('当前没有可预览的图片')
    }
  }
}
</script>

<style lang="less" scoped>
.bk {
  position: relative;
  width: 100vw;
  height: 87.3333vw;
  background-image: url(../assets/img/集团介绍与架构_banner_mob.png);
  background-size: 100% 100%;
}
.bk div {
  position: absolute;
  // left: 21.2vw;
  left: 50%;
  transform: translate(-50%);
  top: 39.4667vw;
  font-size: 6.4vw;
  height: 8vw;
  line-height: 8vw;
  letter-spacing: 1.828vw;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  z-index: 1;
}
.headerTitle {
  margin: 0 auto;
}
.title {
  height: 8vw;
  line-height: 8vw;
  text-align: center;
  margin-top: 4.8vw;
  font-size: 24px;
  font-family: AlibabaPuHuiTiB;
  color: #140047;
  letter-spacing: 1.828vw;
}
.introduce {
  width: 92vw;
  //   height: 128.9333vw;
  margin: 5.8667vw auto 0px;
  letter-spacing: 0.2667vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #01021b;
  //   line-height: 10.6667vw;
}
.introduce .all {
  font-size: 3.2vw;
  transform-origin: left;
  transform-origin: 0% 0%;
  line-height: 7vw;
}
.bm {
  width: 100%;
  height: 10.6667vw;
  line-height: 10.6667vw;
  background: #030e2c;
  color: #ffffff;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 5.3333vw;
}
.bm span {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  display: block;
  text-align: center;
  width: 100%;
  height: 10.6667vw;
  line-height: 10.6667vw;
  font-size: 3.2vw;
  opacity: 0.5;
  /* transform: scale(0.5); 
    transform-origin: 0 0; */
}
.name {
  display: block;
  margin-top: 10.1333vw;
  margin-left: 33.6vw;
  font-size: 6.4vw;
  line-height: 8vw;
  letter-spacing: 1.8293vw;
}
.imgCe {
  width: 100vw;
  height: 98.6667vw;
  margin-top: 5.3333vw;
}
.imgCe img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
/deep/ .el-button--small {
  float: right;
}
/deep/ .el-image-viewer__wrapper {
  width: 100vw;
  overflow: hidden;
}
/deep/ .el-image-viewer__mask {
  opacity: 1;
  background-color: #ffffff;
}
/deep/ .el-image-viewer__canvas {
  width: 100vw;
  height: 177.8667vw;
}
/deep/ .el-button--primary {
  background: #ffffff;
  border-color: #ffffff;
  width: 5.3333vw;
  height: 5.3333vw;
  background-image: url('../assets/img/icon_Zoom.svg');
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/introduction.vue